import { CardComponentContent } from '../../../types/elearning';
import { wordpressAPI } from '../../../services/wordpressApi';
import { useState, useEffect } from 'react';
import { WPMedia } from '../../../types/wordpress';
import Button from '../../ui/Button';
import { sanitizeElearningHtml } from '../../../utils/elearningHtml';

interface CardViewerProps {
  content: CardComponentContent;
}

export default function CardViewer({ content }: CardViewerProps) {
  const { title, text, imageId, link, linkText } = content;
  const [image, setImage] = useState<WPMedia | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (imageId) {
      setLoading(true);
      wordpressAPI
        .fetchMedia(imageId)
        .then((media) => {
          setImage(media);
        })
        .catch((err) => {
          console.error('Failed to load image:', err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [imageId]);

  return (
    <div className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow mb-4">
      {image && !loading && (
        <div className="w-full h-48 overflow-hidden">
          <img
            src={image.source_url}
            alt={image.alt_text || title}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <div className="p-6">
        {title && (
          <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
        )}
        <div
          className="text-gray-700 mb-4 prose prose-sm max-w-none"
          dangerouslySetInnerHTML={{ __html: sanitizeElearningHtml(text) }}
        />
        {link && linkText && (
          <Button
            variant="primary"
            onClick={() => window.open(link, '_blank')}
            className="w-full sm:w-auto"
          >
            {linkText}
          </Button>
        )}
      </div>
    </div>
  );
}
